import { render, staticRenderFns } from "./ScoreRun.vue?vue&type=template&id=e052cc10&scoped=true&"
import script from "./ScoreRun.vue?vue&type=script&lang=js&"
export * from "./ScoreRun.vue?vue&type=script&lang=js&"
import style0 from "./ScoreRun.vue?vue&type=style&index=0&id=e052cc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052cc10",
  null
  
)

export default component.exports